var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 7,
    viewBox: "0 0 10 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.53003 0.970002C9.67048 1.11063 9.74937 1.30125 9.74937 1.5C9.74937 1.69875 9.67048 1.88938 9.53003 2.03L5.53003 6.03C5.38941 6.17045 5.19878 6.24934 5.00003 6.24934C4.80128 6.24934 4.61066 6.17045 4.47003 6.03L0.470031 2.03C0.396344 1.96134 0.337242 1.87854 0.29625 1.78654C0.255258 1.69454 0.233217 1.59523 0.23144 1.49452C0.229663 1.39382 0.248188 1.29379 0.285909 1.2004C0.32363 1.10702 0.379774 1.02218 0.450993 0.950963C0.522212 0.879745 0.607045 0.8236 0.700434 0.785879C0.793822 0.748158 0.893851 0.729633 0.994554 0.731409C1.09526 0.733186 1.19457 0.755228 1.28657 0.79622C1.37857 0.837212 1.46137 0.896315 1.53003 0.970002L5.00003 4.44L8.47003 0.970002C8.61066 0.829551 8.80128 0.750661 9.00003 0.750661C9.19878 0.750661 9.38941 0.829551 9.53003 0.970002Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.2c88d0a8881c8930913bd477befd1b6a.svg";
export { ForwardRef as ReactComponent };